import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { config } from '../../config';

// Define interface for extra options
interface ExtraOptions {
  authHeaders?: Record<string, string>;
}

// Custom base query that handles auth dynamically
const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  // Create a base query instance
  const baseQuery = fetchBaseQuery({
    baseUrl: config.API_URL,
    credentials: 'include',
  });

  const authHeaders = (extraOptions as ExtraOptions)?.authHeaders;

  if (typeof args === 'string') {
    args = { url: args };
  }

  const argsWithAuth = {
    ...args,
    headers: {
      ...args.headers,
      'X-Api-Key': config.API_KEY,
      ...(authHeaders || {}),
    },
  };

  return baseQuery(argsWithAuth, api, extraOptions);
};

export const climateApi = createApi({
  reducerPath: 'climateApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getClimateData: builder.query({
      query: (params) => ({
        url: '/climate/data',
        method: 'GET',
        params,
      }),
    }),
    getLocationRisks: builder.query({
      query: (locationId) => `/climate/location/${locationId}/risks`,
    }),
    getClimateForecasts: builder.query({
      query: (params) => ({
        url: '/climate/forecasts',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useGetClimateDataQuery,
  useGetLocationRisksQuery,
  useGetClimateForecastsQuery,
} = climateApi;
